// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eQ3cp","right":"styles_right__jdT3s"};